import Crop169Icon from "@mui/icons-material/Crop169";
import CropDinIcon from "@mui/icons-material/CropDin";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { AspectRatioIconType, useVideo } from "../../../../../context/juno/VideoContext";
import { isDurationSliderDisabledForEngine } from "../../../../../utils/validation/videoValidation";
import { ColumnBox, RowBox, RowCenteredBox } from "../../../../../utils/styledBox";
import AspectRatioIcons from "../AspectRatioIcons";
import ImageUpload from "../ImageUpload";
import ModelVersionSelectBox from "../ModelVersionSelectBox";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { IconButton, TextField, Tooltip } from "@mui/material";
import { Info } from "@mui/icons-material";

const ParamsKling = () => {
  const { t } = useTranslation();
  const {
    menu,
    updateParams,
    image1,
    setImage1,
    duration,
    modelVersion,
    image2,
    setImage2,
    guidanceScales,
    negativePrompt,
    setNegativePrompt,
  } = useVideo();

  // 2枚目の画像がセットされた場合は5秒に制限
  useEffect(() => {
    if (isDurationSliderDisabledForEngine("KLING", modelVersion.KLING, menu, image1, image2) && duration.KLING !== 5) {
      updateParams("KLING", "duration", 5);
    }
  }, [modelVersion.KLING, menu, image1, image2, duration.KLING, updateParams]);

  const aspectRatio: AspectRatioIconType[] = [
    { ratio: "1:1", icon: CropDinIcon },
    { ratio: "16:9", icon: Crop169Icon },
    { ratio: "9:16", icon: Crop169Icon, rotate: "90deg" },
  ];

  const durationMarks = [
    {
      value: 5,
      label: "5s",
    },
    {
      value: 10,
      label: "10s",
    },
  ];

  const replaceImage = () => {
    const tmp = image1;
    setImage1(image2);
    setImage2(tmp);
  };

  return (
    <ColumnBox sx={{ gap: 4 }}>
      <ColumnBox>
        {/* Model */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.ai.model")}
        </Typography>
        <ModelVersionSelectBox
          platform="KLING"
          value={modelVersion.KLING}
          onChange={(value) => updateParams("KLING", "modelVersion", value)}
          menu={menu}
        />
      </ColumnBox>
      <ColumnBox>
        {/* Duration */}
        <Typography variant="body2" mb={1}>
          {t("juno.video.params.duration")}
        </Typography>
        <Slider
          aria-label="duration"
          marks={durationMarks}
          min={5}
          max={10}
          step={5}
          value={duration.KLING}
          onChange={(_, value) => updateParams("KLING", "duration", value)}
          disabled={isDurationSliderDisabledForEngine("KLING", modelVersion.KLING, menu, image1, image2)}
        />
      </ColumnBox>

      {menu === "i2v" &&
        (modelVersion.KLING === "V1_0_STANDARD" ||
          modelVersion.KLING === "V1_6_STANDARD" ||
          modelVersion.KLING === "V2_MASTER") && (
          <ColumnBox sx={{ justifyContent: "center" }}>
            <Typography variant="body2" mb={1}>
              {t("juno.video.params.upload")}
            </Typography>
            <ImageUpload image={image1} setImage={setImage1} />
          </ColumnBox>
        )}
      {menu === "i2v" &&
        (modelVersion.KLING === "V1_0_PRO" ||
          modelVersion.KLING === "V1_5_PRO" ||
          modelVersion.KLING === "V1_6_PRO") && (
          <ColumnBox sx={{ justifyContent: "center" }}>
            <Typography variant="body2" mb={1}>
              {t("juno.video.params.upload")} - FIRST
            </Typography>
            <ImageUpload image={image1} setImage={setImage1} />
            <RowCenteredBox sx={{ my: 2 }}>
              <IconButton onClick={() => replaceImage()}>
                <SwapVertIcon />
              </IconButton>
            </RowCenteredBox>
            <Typography variant="body2" mb={1}>
              {t("juno.video.params.upload")} - LAST
            </Typography>
            <ImageUpload image={image2} setImage={setImage2} />
          </ColumnBox>
        )}

      <ColumnBox>
        {/* aspect */}
        <AspectRatioIcons aspectRatioList={aspectRatio} />
      </ColumnBox>

      <ColumnBox>
        <RowBox sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="body2" mb={1}>
            {t("juno.video.params.guidanceScale")}
          </Typography>
          <Tooltip title={t("juno.video.params.guidanceScaleHelp")} placement="top">
            <IconButton size="small">
              <Info fontSize="small" />
            </IconButton>
          </Tooltip>
        </RowBox>
        <Slider
          value={guidanceScales["KLING"]}
          onChange={(_, value) => updateParams("KLING", "guidanceScale", value)}
          min={0.1}
          max={1}
          step={0.1}
          valueLabelDisplay="auto"
          marks={[
            { value: 0.1, label: "0.1" },
            { value: 0.5, label: "0.5" },
            { value: 1, label: "1" },
          ]}
        />
      </ColumnBox>

      {/* ネガティブプロンプト - V2_MASTERモデルの場合のみ表示 */}
      {modelVersion.KLING === "V2_MASTER" && (
        <ColumnBox>
          <Typography variant="body2" mb={1}>
            {t("juno.video.params.negativePrompt")}
          </Typography>
          <TextField
            value={negativePrompt}
            onChange={(e) => setNegativePrompt(e.target.value)}
            variant="standard"
            fullWidth
            multiline
            maxRows={4}
            inputProps={{ maxLength: 500 }}
          />
        </ColumnBox>
      )}
    </ColumnBox>
  );
};
export default ParamsKling;
